module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/alliance/region/region.component.scss
// module id = ./src/app/shared-components/alliance/region/region.component.scss
// module chunks = main